import styled, { css } from "styled-components"
import { Error, TextInput } from "../../../text-input.component"
import { SubscribeButton } from "../../../newsletter.component"
import Section from "../../section.component"
import TextareaWithError from "../../../../commerce/textarea/textarea-with-error.component"
import Checkbox from "../../../commerce/checkbox/checkbox.component"
import Select from "../../../commerce/select/select.component"

export const StyledCustomFormSection = styled(Section)`
  margin-top: calc(-1 * var(--grid-spacing) / 1.6);
`

export const StyledCustomFormButton = styled(SubscribeButton)<{
  success: boolean
  error: boolean
}>`
  grid-area: unset;
  grid-row: auto;
  ${({ error, success, theme }) =>
    (success || error) &&
    css`
      background-color: ${success
        ? theme.color.buttonSuccess
        : theme.color.error};
      &:focus {
        background-color: ${success
          ? theme.color.buttonSuccess
          : theme.color.error};
      }
    `}
`

export const StyledCustomForm = styled.form`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    grid-column-gap: 0;
    & > * {
      grid-column: 1;
      grid-row: auto !important;
    }
  }
`

export const FormInput = styled(TextInput)`
  label {
    font-size: 0.9em;
    color: gray;
  }
  input {
    font-size: 0.9em;
  }
`
export const ErrorTick = styled(Error)`
  height: 11px;
  width: 12px;
  margin-right: 5px;
`

export const StyledCustomFormTextarea = styled(TextareaWithError)`
  grid-row: 6;
  grid-column: 1/3;
  textarea {
    resize: vertical;
    padding-top: 30px;
    padding-left: 15px;
  }
  label {
    @media (max-width: 1000px) {
      top: 5px;
      /* font-size: 10px;
      line-height: 16px; */
    }
  }
`

export const StyledCheckbox = styled(Checkbox)`
  grid-row: 7;
`

export const StyledSelect = styled(Select)`
  grid-row: 5;
  select {
    position: relative;
    z-index: 10;
  }
`
